import Section from "@/components/ui/section";
import Image from "next/image";
import { useEffect, useState } from "react";

const Collage = ({ members }) => {
  return (
      <Section variant="flat">
        <div className="grid grid-cols-2 md:grid-cols-5 lg:grid-cols-5 auto-rows-auto md:gap-2 gap-1.5">
          {/* Row 1 */}
          <ImageBlock members={members} data={members[0]?.image?.data?.attributes} index={0}   alt={members[0]?.image?.data?.attributes?.alternativeText || 'Member Image'}/>
          <div className="w-full h-full bg-beige relative p-4 flex items-end">
            <p className="text-darkGrey/80 font-havletica font-light md:leading-tight leading-tight text-2xl md:text-xl lg:text-[45px]">
              40+ <br />
              TEAM MEMBERS
            </p>
          </div>
          <ImageBlock members={members} data={members[1]?.image?.data?.attributes} index={1}   alt={members[1]?.image?.data?.attributes?.alternativeText || 'Member Image'} />
          <ImageBlock members={members} data={members[2]?.image?.data?.attributes} index={2}   alt={members[2]?.image?.data?.attributes?.alternativeText || 'Member Image'} />
          <ImageBlock members={members} data={members[4]?.image?.data?.attributes} index={4}    alt={members[4]?.image?.data?.attributes?.alternativeText || 'Member Image'}/>

          {/* Row 2 */}
          <ImageBlock members={members} data={members[5]?.image?.data?.attributes} index={5}    alt={members[5]?.image?.data?.attributes?.alternativeText || 'Member Image'}/>
          <ImageBlock members={members} data={members[6]?.image?.data?.attributes} index={6}    alt={members[6]?.image?.data?.attributes?.alternativeText || 'Member Image'}/>
          <ImageBlock members={members} data={members[7]?.image?.data?.attributes} index={7}    alt={members[7]?.image?.data?.attributes?.alternativeText || 'Member Image'}/>
          <div className="w-full h-full bg-beige relative lg:p-4 p-3 flex items-end lg:col-span-2">
            <p className="text-darkGrey/80 font-havletica font-light leading-tight text-lg lg:text-2xl">
              We are doing
              <br /> projects in 15+ cities
            </p>
          </div>

          {/* Row 3 */}
          <ImageBlock members={members} data={members[8]?.image?.data?.attributes} index={8}    alt={members[8]?.image?.data?.attributes?.alternativeText || 'Member Image'}/>
          <div className="w-full h-full bg-beige relative lg:p-4 p-3 flex items-end lg:col-span-2">
            <p className="text-darkGrey/80 font-havletica font-light leading-tight text-lg lg:text-2xl">
              14000+ hours of <br /> continuous working
            </p>
          </div>
          <ImageBlock members={members} data={members[9]?.image?.data?.attributes} index={9}    alt={members[9]?.image?.data?.attributes?.alternativeText || 'Member Image'}/>
          <ImageBlock members={members} data={members[10]?.image?.data?.attributes} index={10}   alt={members[10]?.image?.data?.attributes?.alternativeText || 'Member Image'} />

          {/* Row 4 */}
         {/* <ImageBlock members={members} data={members[11]?.image?.data?.attributes} index={11} />
          <ImageBlock members={members} data={members[12]?.image?.data?.attributes} index={12} />
          <ImageBlock members={members} data={members[13]?.image?.data?.attributes} index={13} />
          <ImageBlock members={members} data={members[14]?.image?.data?.attributes} index={14} />
          <div className="w-full h-full bg-beige relative lg:p-4 p-3 flex items-center justify-center">
            <p className="text-darkGrey/80 font-havletica font-light text-center lg:leading-normal leading-tight text-lg md:text-xl lg:text-2xl uppercase lg:max-w-[150px]">
              Create Together, Stay Together
            </p>
          </div>*/}

          {/* Extra Members */}
         {/* {members?.slice(15)?.map((member, index) => (
              <ImageBlock key={index + 15} members={members} data={member.image?.data?.attributes} index={index + 15} />
          ))} TODO SSS*/}

          {Array.isArray(members) &&
              members.slice(15).map((member, index) => (
                  <ImageBlock
                      key={index + 15}
                      members={members}
                      data={member.image?.data?.attributes}
                      index={index + 15}
                      alt={member.image?.data?.attributes?.alternativeText || `Member ${index + 15}`}
                  />
              ))}
        </div>
      </Section>
  );
};

const getReverseImage = (members, index) => {
  const reverseIndex = members.length - 1 - index;
  return members[reverseIndex]?.image?.data?.attributes;
};

const getRandomDelay = (min = 4000, max = 8000) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const ImageBlock = ({ data, members, index }) => {
  console.log(index);
 // console.log(members.image?.data?.attributes);
  //console.log(members);
  console.log(data);
  const [showFirst, setShowFirst] = useState(true);
  const reversedData = getReverseImage(members, index);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFirst((prev) => !prev);
    }, getRandomDelay());

    return () => clearTimeout(timer);
  }, [showFirst]);

  return (
      <div className="relative w-full 2xl:h-[25vw] lg:h-[364px] md:h-[180px] h-[200px] overflow-hidden">
        {/* Main Image */}
        <Image
            src={data?.url ?? "/images/placeholder.svg"}
            alt={data?.alternativeText ?? "Member Image"}
            fill
            quality={100}
            sizes="500px"
            className={`absolute transition-opacity duration-1000 ease-in-out top-0 left-0 w-full h-full object-cover object-center ${
                showFirst ? "opacity-100" : "opacity-0"
            }`}
        />
        {/* Reverse Image */}
        {reversedData && (
            <Image
                src={reversedData?.url ?? "/images/placeholder.svg"}
                alt={reversedData?.alternativeText ?? "Member Image"}
                fill
                quality={100}
                sizes="500px"
                className={`absolute transition-opacity duration-1000 ease-in-out top-0 left-0 w-full h-full object-cover object-center ${
                    showFirst ? "opacity-0" : "opacity-100"
                }`}
            />
        )}
      </div>
  );
};

export default Collage;